var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dim-twin",attrs:{"data-label":_vm.label},on:{"mouseover":function($event){return _vm.onMouseEnter(_vm.label)},"mouseleave":_vm.onMouseLeave}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }